export enum ToastType {
  INFO = 'INFO',
  REMINDER = 'REMINDER',
}
export interface ToastProps {
  type: ToastType;
  text: string;
  showToast: boolean;
  onConfirm?: () => void;
  onDismiss: () => void;
}
